import React from "react";
import styles from "./OrderInitiatePage.module.css";

const PCT_OF_MARGIN_TITLE = "% of margin required";

function percentToneClass(pctStr) {
  if (pctStr == null || pctStr === "" || pctStr === "—") return styles.neutral;
  const s = String(pctStr);
  if (s.startsWith("-") || s.startsWith("−")) return styles.negative;
  return styles.positive;
}

function TopMetricsRow({
  heading = "Strategy Summary",
  maxProfitVal,
  minProfitVal,
  maxProfitPct = "—",
  maxLossPct = "—",
  metricsGrid,
}) {
  return (
    <div className={styles.topMetricsSection}>
      <h2 className={styles.topMetricsHeading}>{heading}</h2>
      <div className={styles.topMetricsRow}>
        <div className={styles.profitCard}>
          <div className={styles.profitCardHeader}>
            <span className={styles.profitCardTitle}>Max Profit</span>
            <span
              className={`${styles.profitCardPercent} ${percentToneClass(maxProfitPct)}`}
              title={PCT_OF_MARGIN_TITLE}
            >
              {maxProfitPct}
            </span>
          </div>
          <div className={styles.profitCardValue}>{maxProfitVal}</div>
        </div>
        <div className={styles.profitCard}>
          <div className={styles.profitCardHeader}>
            <span className={styles.profitCardTitle}>Max Loss</span>
            <span
              className={`${styles.profitCardPercent} ${percentToneClass(maxLossPct)}`}
              title={PCT_OF_MARGIN_TITLE}
            >
              {maxLossPct}
            </span>
          </div>
          <div className={styles.profitCardValue}>{minProfitVal}</div>
        </div>
        {metricsGrid.map((item) => (
          <div key={item.label} className={styles.metricsBlock}>
            <div className={styles.metricsValue}>{item.value}</div>
            <div className={styles.metricsLabel}>{item.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default React.memo(TopMetricsRow);
